
import Vue from "vue";
import { namespace } from "vuex-class";
import { Component, Watch } from "vue-property-decorator";
import CadastroUserComponent from "@/components/login/CadastroUser.vue";
import RecuperacaoSenhaComponent from "@/components/login/RecuperacaoSenha.vue";
import LoginFormComponent from "@/components/login/LoginForm.vue";
import AlteracaoSenhaComponent from "@/components/login/AlteracaoSenha.vue";

const Auth = namespace("Auth");

@Component({
  components: {
    LoginFormComponent,
    CadastroUserComponent,
    RecuperacaoSenhaComponent,
    AlteracaoSenhaComponent,
  },
})
export default class LoginDialog extends Vue {
  //   dialog = true;
  currentView = "LoginFormComponent";
  
  @Auth.Getter
  private isLoggedIn!: boolean;
  
  @Auth.Getter
  private getLoginDialogStatus!: any;

  get dialogWidth() {
    switch (this.currentView) {
      case "LoginFormComponent":
        return "400px";
      case "AlteracaoSenhaComponent":
      case "RecuperacaoSenhaComponent":
        return "500px";

      default:
        return "600px";
    }
  }

  onDialogVisibilityChanged(newValue: boolean) {
    this.getLoginDialogStatus.visible = newValue;
  }

  @Watch("getLoginDialogStatus.visible")
  onDialogVisibleChange(value: any) {
    this.currentView = "LoginFormComponent";
    if (value) {
      const view = this.$refs.comp as any;
      view?.reset();
    }
  }

  @Watch("isLoggedIn")
  onUserLoggedIn(value: boolean, oldValue: boolean) {
    if (!oldValue && value) this.loginEfetuado();
  }

  loginEfetuado() {
    // this.dialog = false;
    this.getLoginDialogStatus.visible = false;
    if (this.$router.currentRoute.path !== `/home`) this.$router.push("/home");
  }

  efetuarRecSenha() {
    this.currentView = "LoginFormComponent";
  }

  recuperarSenha() {
    this.currentView = "RecuperacaoSenhaComponent";
  }

  alterarSenha() {
    this.currentView = "AlteracaoSenhaComponent";
  }

  criarCadastro() {
    this.currentView = "CadastroUserComponent";
  }

  voltarTelaLogin() {
    this.currentView = "LoginFormComponent";
  }

  fecharDialog() {
    this.getLoginDialogStatus.visible = false;
  }
}
